<template>
    <v-container>
      <v-dialog v-model="dialogEvent" persistent scrollable max-width="450">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{$t('event_data')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogEvent = false, qr_code='', a_qr_code = '', entrada = false, salida = false, activar_camara = true"
              ><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="heading text-justify black--text">
                    <p>
                      <br><strong>{{$t('event_name')}}: <BIG><U>{{eventData.name}}</U></BIG></strong><br>
                      <strong>{{$t('direccion')}}: <BIG>{{eventData.address}}</BIG></strong><br>
                      <strong>{{$t('Fecha')}}: <BIG>{{eventData.date}}</BIG></strong>&nbsp;&nbsp;&nbsp;
                      <strong>{{$t('event_time')}}: <BIG>{{eventData.time}}</BIG></strong><br>
                    </p>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                      :headers="headersEvent"
                      :hide-default-footer="true"
                      :items="guestsByEvent"
                      :footer-props="{
                                        itemsPerPageOptions: [
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}
                                        ],
                                        itemsPerPageText: $t('filas_por_pagina')
                                    }"
                      :no-data-text="$t('no_records_yet')"
                      class="elevation-1"
                  >
                    <template v-slot:item.status="{ item }">
                      <div v-if="item.status === 0">
                          <v-btn
                                  @click="checkInGuestByEvent(item)"
                                  color="primary">
                              {{$t('complete_register')}}
                          </v-btn>
                      </div>
                      <div v-else>
                          <v-icon color="primary">mdi-check</v-icon>{{$t('adentro')}}
                      </div>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar info de Torneo / Casa Club (type_code 4)    -->
        <v-dialog v-model="dialogTournament" persistent scrollable max-width="480">
          <v-card v-if="tournamentData" class="elevation-8 tournament-preview-card">
            <v-toolbar dark flat class="tournament-toolbar" height="64">
              <v-icon left size="28">mdi-golf</v-icon>
              <v-toolbar-title class="text-subtitle-1 font-weight-bold">
                ACCESO TORNEO
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="closeTournamentDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-5">
              <v-row align="center" no-gutters>
                <v-col cols="12" sm="3" class="text-center mb-4 mb-sm-0">
                  <div class="tournament-avatar">{{ getTournamentInitials(tournamentData.full_name) }}</div>
                </v-col>
                <v-col cols="12" sm="9">
                  <div class="tournament-summary">
                    <div class="tournament-kicker">Invitado a torneo</div>
                    <h2 class="tournament-name">{{ tournamentData.full_name }}</h2>
                    <div class="tournament-event">{{ tournamentData.tournament || tournamentData.club }}</div>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-3" dense>
                <v-col cols="6" md="4">
                  <div class="tournament-info-box">
                    <div class="info-label">Código</div>
                    <div class="info-value">{{ tournamentData.access_code }}</div>
                  </div>
                </v-col>
                <v-col cols="6" md="4">
                  <div class="tournament-info-box">
                    <div class="info-label">Club</div>
                    <div class="info-value">{{ tournamentData.club }}</div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="tournament-info-box">
                    <div class="info-label">Estado</div>
                    <div class="info-value">
                      <v-chip v-if="tournamentData.attended" x-small color="green" text-color="white" class="font-weight-bold">
                        <v-icon left x-small>mdi-check-circle</v-icon>Adentro
                      </v-chip>
                      <v-chip v-else x-small color="blue darken-2" text-color="white" class="font-weight-bold">
                        Pendiente
                      </v-chip>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <template v-if="tournamentData.guests && tournamentData.guests.length > 0">
                <v-divider class="my-4"></v-divider>
                <div class="tournament-kicker mb-2">Invitados</div>
                <div class="guest-sublist">
                  <div
                      v-for="guest in tournamentData.guests"
                      :key="guest.id"
                      class="d-flex align-center justify-space-between guest-row px-4 py-2"
                  >
                    <div class="d-flex align-center">
                      <v-icon small color="blue darken-2" class="mr-2">mdi-account-arrow-right</v-icon>
                      <span class="font-weight-medium">{{ guest.full_name }}</span>
                    </div>
                    <v-chip v-if="guest.attended" x-small color="green" text-color="white" class="font-weight-bold">
                      <v-icon left x-small>mdi-check-circle</v-icon>Adentro
                    </v-chip>
                    <v-btn v-else small color="blue darken-2" dark @click="grantTournamentAccess(guest, tournamentData)">
                      <v-icon left small>mdi-login</v-icon>
                      ACCESO
                    </v-btn>
                  </div>
                </div>
              </template>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-center pa-4">
              <v-btn large outlined color="error" @click="closeTournamentDialog()">
                Cerrar
              </v-btn>
              <template v-if="!tournamentData.attended">
                <v-spacer></v-spacer>
                <v-btn large color="blue darken-2" dark @click="grantTournamentAccess(tournamentData)">
                  <v-icon left>mdi-login</v-icon>
                  Permitir ingreso
                </v-btn>
              </template>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Correccion de Datos    -->
        <v-dialog v-model="dialog_correction_request" persistent width="500">
            <v-card class="justify-center">
                <v-card-title class="primary display-1 text--primary justify-center">
                    {{$t('data_correction')}}
                </v-card-title>
                <v-card-text align="center">
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                          v-model="first_name_correction"
                          prepend-icon="mdi-account"
                          name="first_name"
                          :label="$t('Nombre')"
                          :error-messages="errores.first_name"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                          v-model="last_name_correction"
                          prepend-icon="mdi-account-outline"
                          name="last_name"
                          :label="$t('Apellido')"
                          :error-messages="errores.last_name"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-checkbox
                          v-model="msg_photograph_blurred"
                          :label="$t('msg_photograph_blurred')">
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialog_correction_request = false"
                    >
                        {{$t('cancelar')}}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                            color="primary"
                            :loading="loading_correction_request"
                            @click="send_correction_request()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialogInitial" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('selecciona_caseta')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form
                                @submit.prevent="setGuardHouse()">
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                        v-model="guardHouse"
                                        name="guardHouse"
                                        :items="guardHouses"
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('Casetas')"
                                        autocomplete="off"
                                ></v-autocomplete>
                            </v-col>
                            <v-btn
                                    color="primary"
                                    type="submit"
                            >{{ $t('aceptar') }}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores en Accesos    -->
        <v-dialog
                v-model="dialog_errores"
                persistent
                width="500"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text align="center">
                    <h3 class="text-xs-center">{{errores_guard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', activar_camara = true"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
            <v-card v-if="entradaResidente" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_residente')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, qr_code = '', entrada = false, salida = false, entradaResidente = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.resident).length > 0">
                          <v-layout justify-center class="text-xs-center" row wrap>
                            <v-alert
                                v-show="info_invitation.resident.vacation_mode && !info_invitation.resident.allow_access_residents"
                                type="error"
                            >
                                <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                            </v-alert>
                            <br>
                            <v-alert
                                v-show="info_invitation.resident.instructions !== '' && info_invitation.resident.instructions !== null"
                                type="info"
                            >
                                <strong>{{ info_invitation.resident.instructions }}</strong>
                            </v-alert>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.resident.idUser.idFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('residente')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.resident.idUser.first_name}}
                                                        {{ info_invitation.resident.idUser.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.resident.street}} {{info_invitation.resident.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{  info_invitation.resident.idUser.cellNumber}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="success"
                            @click="dialog = false, qr_code = '', entrada = false, salida = false, entradaResidente = false, activar_camara = true"
                    >{{$t('acceso')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-if="entrada" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.invitation).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-alert
                                    v-show="info_invitation.invitation.supplier"
                                    type="info"
                                >
                                  <strong>{{$t('supplier_mode')}}</strong>{{$t('msg_supplier')}}
                                </v-alert>
                                <v-alert
                                    v-show="info_invitation.invitation.vacation_mode && !info_invitation.invitation.allow_access_visitors"
                                    type="error"
                                >
                                  <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                </v-alert>
                                <v-alert
                                    v-show="info_invitation.invitation.instructions !== '' && info_invitation.invitation.instructions !== null"
                                    type="info"
                                >
                                  <strong>{{ info_invitation.invitation.instructions }}</strong>
                                </v-alert>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.correction_request === false">
                                                        {{ info_invitation.invitation.guestFName}}
                                                        {{ info_invitation.invitation.guestLName}}
                                                    </h2>
                                                    <h2 v-else style="color: red">
                                                        {{ info_invitation.invitation.first_name}}
                                                        {{ info_invitation.invitation.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-show="info_invitation.invitation.correction_request === false" align-center justify-center row wrap>
                                    <v-btn
                                        large
                                        color="error"
                                        @click="id_user_settings = info_invitation.invitation.id_user_settings, first_name_correction = info_invitation.invitation.guestFName, last_name_correction = info_invitation.invitation.guestLName, msg_photograph_blurred = true, errores = [], dialog_correction_request = true"
                                    >{{$t('send_correction_request')}}
                                    </v-btn>
                                </v-layout>
                                <v-layout v-show="info_invitation.invitation.correction_request === true" align-center justify-center row wrap>
                                    <v-btn
                                        disabled
                                        large
                                        color="error">
                                      {{$t('data_correction_sent')}}
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                            <v-divider :inset="false"></v-divider>
                            <v-flex v-show="getProfile.enable_host_info" xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                v-if="getProfile.enable_ine_photo"
                                                :src="info_invitation.invitation.hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-img
                                                v-else
                                                :src="info_invitation.invitation.avatarHost"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostFirstName}}
                                                        {{ info_invitation.invitation.hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="text-center">
                    <v-flex xs12>
                      <v-text-field
                          :disabled="!entrada"
                          class="mr-5 ml-5"
                          v-model="comments"
                          name="comments"
                          outlined
                          autocomplete="off"
                          maxlength="300"
                          prepend-icon="mdi-text"
                          :label="$t('Notas')"
                          :error-messages="errores.commnets"
                      ></v-text-field>
                      <v-btn
                              large
                              color="error"
                              @click="dialog = false, activar_camara = true"
                      >{{this.$t('cerrar')}}
                    </v-btn>
                      <v-btn
                              large
                              color="success"
                              @click="create_acceso(), dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                      >{{$t('acceso')}}
                    </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
            <v-card v-if="entradaTrabajador || salidaTrabajador" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.worker).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_worker')}}</h2>
                                <br>
                                <v-alert
                                    v-show="info_invitation.worker.vacation_mode && !info_invitation.worker.allow_access_workers"
                                    type="error"
                                >
                                  <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                                </v-alert>
                                <v-alert
                                    v-show="info_invitation.worker.instructions !== '' && info_invitation.worker.instructions !== null"
                                    type="info"
                                >
                                  <strong>{{ info_invitation.worker.instructions }}</strong>
                                </v-alert>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.worker.avatar"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('worker')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.first_name}}
                                                        {{ info_invitation.worker.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.street}} {{info_invitation.worker.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('check_in_time')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.check_in_time}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('check_out_time')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.check_out_time}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_inicial')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.initial_date }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.worker.final_date }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.worker.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.worker.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="text-center">
                  <v-flex xs12>
                      <v-text-field
                          v-show="entradaTrabajador"
                          class="mr-5 ml-5"
                          v-model="comments"
                          name="comments"
                          outlined
                          autocomplete="off"
                          maxlength="300"
                          prepend-icon="mdi-text"
                          :label="$t('Notas')"
                          :error-messages="errores.commnets"
                      ></v-text-field>
                      <v-btn
                              large
                              color="error"
                              @click="dialog = false, activar_camara = true"
                      >{{this.$t('cerrar')}}
                      </v-btn>
                      <v-btn
                              v-if="entradaTrabajador"
                              large
                              color="success"
                              @click="create_worker_acceso(), dialog = false, qr_code='', activar_camara = true"
                      >{{$t('acceso')}}
                      </v-btn>
                      <v-btn
                              v-else
                              large
                              color="success"
                              @click="create_worker_acceso(), dialog = false, qr_code='', activar_camara = true"
                      >{{$t('registrar_salida')}}
                      </v-btn>
                  </v-flex>
                </v-card-actions>
            </v-card>
            <v-card v-if="entradaContratista || salidaContratista" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.contractor).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_contractor')}}</h2>
                                <br>
                                <v-alert
                                    v-show="info_invitation.contractor.instructions !== '' && info_invitation.contractor.instructions !== null"
                                    type="info"
                                >
                                  <strong>{{ info_invitation.contractor.instructions }}</strong>
                                </v-alert>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.contractor.avatar"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('contractor')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.contractor.first_name}}
                                                        {{ info_invitation.contractor.last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.contractor.street}} {{info_invitation.contractor.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('check_in_time')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.contractor.check_in_time}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('check_out_time')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.contractor.check_out_time}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_inicial')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.contractor.initial_date }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.contractor.final_date }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.contractor.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.contractor.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.contractor.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.contractor.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.contractor.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.contractor.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.contractor.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="text-center">
                  <v-flex xs12>
                      <v-text-field
                          v-show="entradaContratista"
                          class="mr-5 ml-5"
                          v-model="comments"
                          name="comments"
                          outlined
                          autocomplete="off"
                          maxlength="300"
                          prepend-icon="mdi-text"
                          :label="$t('Notas')"
                          :error-messages="errores.commnets"
                      ></v-text-field>
                      <v-btn
                              large
                              color="error"
                              @click="dialog = false, activar_camara = true"
                      >{{this.$t('cerrar')}}
                      </v-btn>
                      <v-btn
                              v-if="entradaContratista"
                              large
                              color="success"
                              @click="create_contractor_acceso(), dialog = false, qr_code='', activar_camara = true"
                      >{{$t('acceso')}}
                      </v-btn>
                      <v-btn
                              v-else
                              large
                              color="success"
                              @click="create_contractor_acceso(), dialog = false, qr_code='', activar_camara = true"
                      >{{$t('registrar_salida')}}
                      </v-btn>
                  </v-flex>
                </v-card-actions>
            </v-card>
            <v-card v-if="salida" color="blue-grey lighten-4" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="Object.keys(info_invitation.invitation).length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="info_invitation.invitation.guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestFName}}
                                                        {{ info_invitation.invitation.guestLName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="info_invitation.invitation.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="info_invitation.invitation.typeInv === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                                <br>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex v-show="getProfile.enable_host_info" xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                v-if="getProfile.enable_ine_photo"
                                                :src="info_invitation.invitation.hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-img
                                                v-else
                                                :src="info_invitation.invitation.avatarHost"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostFirstName}}
                                                        {{ info_invitation.invitation.hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('celular')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('numero_casa')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ info_invitation.invitation.street}} {{info_invitation.invitation.numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-divider inset="false"></v-divider>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('Información de Acceso')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <table :color="data_access[0].pase_salida ? 'success' : 'error'"  id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fecha y hora de acceso')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_access[0].dateTime_EntranceAccess}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fecha y hora de salida')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_access[0].dateTime_ExitAccess ? data_access[0].dateTime_ExitAccess : "Pendiente" }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Estado')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{data_access[0].status == '1' ? "Adentro" : "Afuera"}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br>
                </v-card-text>
                <v-card-actions class="justify-center">
                        <v-btn
                                large
                                color="error"
                                @click="dialog = false, activar_camara = true"
                        >{{ $t('cerrar')}}
                        </v-btn>
                        <v-btn
                                large
                                color="success"
                                @click="update_acceso(data_access[0].id), activar_camara = true"
                        >{{$t('registrar_salida')}}
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="6"
            >
                <v-card
                    width="750px"
                    class="mx-auto elevation-7"
                    align="center"
                    justify="center"
                >
                    <v-toolbar color="primary">
                        <v-toolbar-title>
                            {{$t('entradas_salidas')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h3>{{$t('mensaje_acercar_QR')}}</h3>

                        <!-- Camera Mode Selector -->
                        <v-radio-group v-model="cameraMode" row @change="onCameraModeChange" class="mb-2 mt-0">
                          <v-radio label="Cámara Local" value="local"></v-radio>
                          <v-radio label="Cámara intrare" value="server"></v-radio>
                        </v-radio-group>

                        <v-flex>
                            <!-- Local camera: legacy QrcodeStream unchanged -->
                            <qrcode-stream v-if="activar_camara && cameraMode === 'local'" @decode="onDecode" @init="onInit"/>

                            <!-- Server camera: v-show para que el <video> nunca salga del DOM -->
                            <div v-show="cameraMode === 'server'">
                              <v-select
                                v-if="serverCameras.length > 0"
                                outlined
                                dense
                                v-model="selectedServerCamera"
                                :items="serverCameras"
                                label="Cámara"
                                item-text="name"
                                return-object
                                class="mb-2"
                                @change="onServerCameraChange"
                              ></v-select>
                              <div style="position:relative;width:100%;background:#000;border-radius:4px;overflow:hidden;">
                                <video
                                  ref="videoQR"
                                  autoplay
                                  muted
                                  playsinline
                                  style="width:100%;display:block;"
                                ></video>
                                <div v-if="!selectedServerCamera" style="padding:20px;color:white;text-align:center;">
                                  Cargando cámaras...
                                </div>
                              </div>
                            </div>

                            <p class="error">{{ error }}</p>
                        </v-flex>
                        <v-form @submit.prevent="get_invitation_manual()">
                            <v-flex xs5>
                                <v-text-field
                                        v-model="a_qr_code"
                                        autofocus
                                        prepend-icon="mdi-qrcode"
                                        name="a_qr_code"
                                        :label="$t('qr_code')"
                                        :placeholder="$t('msg_qr_code')"
                                        autocomplete="off"
                                >
                                </v-text-field>
                                <v-btn
                                        color="primary"
                                        large
                                        :loading="loading"
                                        type="submit"
                                >{{$t('enviar')}}
                                </v-btn>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import jsQR from 'jsqr'
import store from '@/store'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'checkin_checkout',
  components: {
    QrcodeStream
  },
  data () {
    return {
      activar_camara: true,
      qr_code: '',
      error: '',
      valido: false,
      a_qr_code: '',
      salida: false,
      entrada: false,
      salidaTrabajador: false,
      entradaTrabajador: false,
      salidaContratista: false,
      entradaContratista: false,
      entradaResidente: false,
      data_access: [],
      errores_guard: '',
      head_color: '',
      info_invitation: [],
      dialog: false,
      comments: '',
      dialog_errores: false,
      dialogInitial: false,
      loading: false,
      guardHouse: null,
      guardHouses: [],
      // VARIABLES CORRECCION DE DATOS
      dialog_correction_request: false,
      first_name_correction: '',
      last_name_correction: '',
      id_user_settings: 0,
      errores: [],
      loading_correction_request: false,
      msg_photograph_blurred: true,
      // VARIABLES CORRECCION DE DATOS
      dialogEvent: false,
      headersEvent: [],
      guestsByEvent: [],
      eventData: [],
      // VARIABLES TORNEO / CASA CLUB (type_code 4)
      dialogTournament: false,
      tournamentData: null,
      // Camera Server Integration
      cameraMode: 'local',
      serverIP: localStorage.getItem('camera_server_ip') || '127.0.0.1:7000',
      serverCameras: [],
      selectedServerCamera: null,
      peerConnection: null,
      cameraAPI: null,
      webrtcNegotiating: false,
      qrScanInterval: null,
      qrDetected: false
    }
  },
  beforeDestroy () {
    this.closeServerCamera()
  },
  watch: {
    activar_camara (val) {
      if (val && this.cameraMode === 'server') {
        // Modal cerrado — el <video> sigue en DOM, solo reanudar escaneo
        this.qrDetected = false
        this.$nextTick(() => {
          const videoEl = this.$refs.videoQR
          // Si el stream se perdió (ej. reconexión), reasignar srcObject
          if (videoEl && !videoEl.srcObject && this.peerConnection) {
            const receivers = this.peerConnection.getReceivers()
            const videoReceiver = receivers.find(r => r.track && r.track.kind === 'video')
            if (videoReceiver) {
              const stream = new MediaStream([videoReceiver.track])
              videoEl.srcObject = stream
              videoEl.play().catch(() => {})
            }
          }
          this.startQRScanning()
        })
      }
    }
  },
  created () {
    this.getGuardHouse()
    // console.log('Basura')
    console.log(localStorage.getItem('idGuardHouse'))
    if (localStorage.getItem('idGuardHouse') === null) {
      this.dialogInitial = true
    }
    console.log('QR TEMPORAL')
    console.log(localStorage.getItem('qr_code_temporal'))
    if (localStorage.getItem('qr_code_temporal') !== null) {
      this.a_qr_code = localStorage.getItem('qr_code_temporal')
    }
  },
  computed: {
    ...mapGetters(['getProfile'])
  },
  beforeUpdate () {
    this.headersEvent = [
      {
        text: this.$t('invitados'),
        align: 'left',
        sortable: true,
        value: 'fullName'
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'status'
      }
    ]
  },
  methods: {
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    updateItemCorrectionRequest () {
      this.info_invitation.invitation.correction_request = true
    },
    send_correction_request: function () {
      this.errores = []
      this.loading_correction_request = true
      console.log(this.qr_code)
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/user/update/correction_request/' + this.id_user_settings,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          first_name: this.first_name_correction,
          last_name: this.last_name_correction
        }
      }
      axios(config)
        .then(response => {
          this.loading_correction_request = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('registro_exito'))
          this.dialog_correction_request = false
          this.updateItemCorrectionRequest()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading_correction_request = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    // ── Camera Server Methods ──────────────────────────────────────────
    initCameraAPI () {
      this.cameraAPI = axios.create({
        baseURL: `http://${this.serverIP}`,
        headers: { 'Content-Type': 'application/json' },
        timeout: 5000
      })
    },
    async loadServerCameras () {
      try {
        if (!this.cameraAPI) this.initCameraAPI()
        const camerasRes = await this.cameraAPI.get('/api/cameras')
        const streamsRes = await this.cameraAPI.get('/api/streams')
        const streams = streamsRes.data.streams || streamsRes.data
        this.serverCameras = camerasRes.data.map(camera => {
          const stream = Array.isArray(streams) && streams.find(s => s.camera_id === camera.id)
          return Object.assign({}, camera, {
            stream_alias: (stream && stream.alias) || camera.alias,
            is_online: (stream && stream.is_online) || false
          })
        })
        if (this.serverCameras.length > 0) {
          this.selectedServerCamera = this.serverCameras[0]
          this.$nextTick(() => this.connectWebRTC(this.selectedServerCamera.stream_alias))
        }
      } catch (error) {
        this.error = 'Error al conectar con servidor de cámaras'
        console.error(error)
      }
    },
    async connectWebRTC (streamAlias) {
      if (this.webrtcNegotiating || !streamAlias) return
      this.webrtcNegotiating = true
      try {
        const config = { iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }] }
        this.peerConnection = new RTCPeerConnection(config)
        this.peerConnection.ontrack = (event) => {
          const videoEl = this.$refs.videoQR
          if (videoEl) {
            videoEl.srcObject = event.streams[0]
            videoEl.play().catch(() => {})
            videoEl.onloadedmetadata = () => this.startQRScanning()
          }
        }
        this.peerConnection.addTransceiver('video', { recv: true })
        const offer = await this.peerConnection.createOffer()
        await this.peerConnection.setLocalDescription(offer)
        const response = await fetch(`http://${this.serverIP}/api/webrtc/${streamAlias}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/sdp' },
          body: this.peerConnection.localDescription.sdp
        })
        if (!response.ok) throw new Error(`Server ${response.status}`)
        const sdp = await response.text()
        await this.peerConnection.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp }))
        this.webrtcNegotiating = false
      } catch (error) {
        console.error('WebRTC error:', error)
        this.error = 'Error al conectar cámara del servidor'
        this.closeServerCamera()
      }
    },
    startQRScanning () {
      this.stopQRScanning()
      this.qrDetected = false
      this.qrScanInterval = setInterval(() => {
        if (this.qrDetected || this.cameraMode !== 'server') {
          this.stopQRScanning()
          return
        }
        const videoEl = this.$refs.videoQR
        if (!videoEl || videoEl.readyState < 2) return
        const canvas = document.createElement('canvas')
        canvas.width = videoEl.videoWidth
        canvas.height = videoEl.videoHeight
        const ctx = canvas.getContext('2d')
        ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height)
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        const code = jsQR(imageData.data, imageData.width, imageData.height)
        if (code && code.data) {
          this.qrDetected = true
          this.stopQRScanning()
          this.onDecode(code.data)
        }
      }, 300)
    },
    stopQRScanning () {
      if (this.qrScanInterval) {
        clearInterval(this.qrScanInterval)
        this.qrScanInterval = null
      }
    },
    closeServerCamera () {
      this.stopQRScanning()
      const videoEl = this.$refs.videoQR
      if (videoEl) { videoEl.srcObject = null; videoEl.pause() }
      if (this.peerConnection) { this.peerConnection.close(); this.peerConnection = null }
      this.webrtcNegotiating = false
    },
    async onCameraModeChange (mode) {
      if (mode === 'server') {
        this.qrDetected = false
        await this.loadServerCameras()
      } else {
        this.closeServerCamera()
      }
    },
    async onServerCameraChange () {
      if (this.selectedServerCamera) {
        this.closeServerCamera()
        await this.$nextTick()
        this.connectWebRTC(this.selectedServerCamera.stream_alias)
      }
    },
    // ── End Camera Server Methods ──────────────────────────────────────

    onDecode (result) {
      this.qr_code = result
      this.get_invitation()
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: you need to grant camera access permisson'
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: installed cameras are not suitable'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: Stream API is not supported in this browser'
        }
      }
    },
    checkInGuestByEvent (item) {
      console.log('item = ', item)
      console.log('this.eventData.idHouse = ', this.eventData.idHouse)
      this.$router.push({
        name: 'access_without_code',
        params: {
          fullNameGuest: item.fullName,
          idHouse: this.eventData.idHouse,
          idGuestByEvent: item.id,
          eventName: this.eventData.name,
          type: 0
        }
      })
    },
    closeTournamentDialog () {
      this.dialogTournament = false
      this.tournamentData = null
      this.qr_code = ''
      this.a_qr_code = ''
      this.activar_camara = true
    },
    getTournamentInitials (fullName) {
      if (!fullName) return ''
      return fullName
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(word => word.charAt(0).toUpperCase())
        .join('')
    },
    grantTournamentAccess (item, parentTournament) {
      // Si viene parentTournament, item es un invitado del torneo; los
      // invitados no traen access_code propio, así que usamos su id.
      const isGuest = !!parentTournament
      const tournament = parentTournament || item
      this.dialogTournament = false
      this.$router.push({
        name: 'access_without_code',
        params: {
          fullNameGuest: item.full_name,
          idGuestByTournament: isGuest ? (item.access_code || item.id) : item.access_code,
          tournamentName: tournament.tournament || tournament.club,
          type: 4
        }
      })
    },
    get_invitation_manual: function () {
      console.log(this.a_qr_code)
      this.loading = true
      if (this.a_qr_code.length === 20) { // Posible Código de Evento
        const config = {
          method: 'get',
          url: 'https://residencial-services.intrare.app/event/qr/' + this.a_qr_code,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        axios(config)
          .then(response => {
            this.loading = false
            this.guestsByEvent = response.data.guests
            this.eventData = response.data.event
            this.dialogEvent = true
            this.valido = true
            console.log('Valido')
            this.activar_camara = false
          })
          .catch(error => {
            this.playSound(require('../../assets/mp3/error01.mp3'))
            this.loading = false
            console.log(error)
            if (error.request.status === 400) {
              this.valido = false
              console.log('Evento Cancelado')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('msg_event_canceled')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
            if (error.request.status === 404) {
              this.valido = false
              console.log('NO Valido')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_qr_no_valido')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
          })
      } else {
        const config = {
          method: 'get',
          url: 'https://residencial-services.intrare.app/vigilant/qr/' + this.a_qr_code,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        axios(config)
          .then(response => {
            this.loading = false
            this.info_invitation = response.data
            console.log(this.info_invitation)
            this.valido = true
            console.log('Valido')
            if (this.info_invitation.type_code === 0) {
              console.log('Acceso por Invitación')
              this.is_access_in_out_both()
            }
            if (this.info_invitation.type_code === 1) {
              console.log('Acceso Residente del Fraccionamiento')
              this.entrada = false
              this.salida = false
              this.entradaResidente = true
              this.entradaTrabajador = false
              this.salidaTrabajador = false
              this.entradaContratista = false
              this.salidaContratista = false
              this.dialog = true
              this.activar_camara = false
            }
            if (this.info_invitation.type_code === 2) {
              console.log('Acceso Trabajador')
              this.is_worker_access_in_out_both()
            }
            if (this.info_invitation.type_code === 3) {
              console.log('Acceso Contratista')
              this.is_contractor_access_in_out_both()
            }
            if (this.info_invitation.type_code === 4) {
              console.log('Acceso Torneo / Casa Club')
              this.tournamentData = this.info_invitation.tournament
              this.dialogTournament = true
              this.activar_camara = false
            }
          })
          .catch(error => {
            this.playSound(require('../../assets/mp3/error01.mp3'))
            this.loading = false
            console.log(error)
            if (error.request.status === 404) {
              this.valido = false
              console.log('NO Valido')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_qr_no_valido')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
            if (error.request.status === 401) {
              this.valido = false
              console.log('Invitacion Expirada')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('msg_out_date2')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
            if (error.request.status === 403) {
              this.valido = false
              console.log('NO Valido')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('msg_canceled_invitation')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
            if (error.request.status === 423) {
              this.valido = false
              console.log('NO Valido')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('msg_vacation_mode_activate')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
            if (error.request.status === 300) {
              this.valido = false
              console.log('Varios registros con el mismo Código QR.')
              this.clear_without_activate_camera()
              this.errores_guard = this.$t('mensaje_qr_multiple')
              this.head_color = 'red display-1 text--primary justify-center'
              this.dialog_errores = true
            }
          })
      }
    },
    playSound (sound) {
      if (sound) {
        let audio = new Audio(sound)
        audio.play()
      }
    },
    get_invitation: function () {
      if (this.qr_code !== '') {
        console.log('Valor de Código QR ', this.qr_code)
        console.log('Tamaño de Código QR ', this.qr_code.length)
        if (this.qr_code.length === 20) { // Posible Código de Evento
          const config = {
            method: 'get',
            url: 'https://residencial-services.intrare.app/event/qr/' + this.qr_code,
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config)
            .then(response => {
              this.loading = false
              this.guestsByEvent = response.data.guests
              this.eventData = response.data.event
              this.dialogEvent = true
              this.valido = true
              console.log('Valido')
              this.activar_camara = false
            })
            .catch(error => {
              this.playSound(require('../../assets/mp3/error01.mp3'))
              this.loading = false
              console.log(error)
              if (error.request.status === 400) {
                this.valido = false
                console.log('Evento Cancelado')
                this.clear_without_activate_camera()
                this.errores_guard = this.$t('msg_event_canceled')
                this.head_color = 'red display-1 text--primary justify-center'
                this.dialog_errores = true
              }
              if (error.request.status === 404) {
                this.valido = false
                console.log('NO Valido')
                this.clear_without_activate_camera()
                this.errores_guard = this.$t('mensaje_qr_no_valido')
                this.head_color = 'red display-1 text--primary justify-center'
                this.dialog_errores = true
              }
            })
        } else {
          const config = {
            method: 'get',
            url: 'https://residencial-services.intrare.app/vigilant/qr/' + this.qr_code,
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config)
            .then(response => {
              this.info_invitation = response.data
              console.log(this.info_invitation)
              this.valido = true
              console.log('Valido')
              if (this.info_invitation.type_code === 0) {
                console.log('Acceso por Invitación')
                this.is_access_in_out_both()
              }
              if (this.info_invitation.type_code === 1) {
                console.log('Acceso Residente del Fraccionamiento')
                this.entrada = false
                this.salida = false
                this.entradaResidente = true
                this.entradaTrabajador = false
                this.salidaTrabajador = false
                this.entradaContratista = false
                this.salidaContratista = false
                this.dialog = true
                this.activar_camara = false
              }
              if (this.info_invitation.type_code === 2) {
                console.log('Acceso Trabajador')
                this.is_worker_access_in_out_both()
              }
              if (this.info_invitation.type_code === 3) {
                console.log('Acceso Contratista')
                this.is_contractor_access_in_out_both()
              }
              if (this.info_invitation.type_code === 4) {
                console.log('Acceso Torneo / Casa Club')
                this.tournamentData = this.info_invitation.tournament
                this.dialogTournament = true
                this.activar_camara = false
              }
            })
            .catch(error => {
              this.playSound(require('../../assets/mp3/error01.mp3'))
              console.log(error)
              if (error.request.status === 404) {
                this.valido = false
                console.log('NO Valido')
                this.clear_without_activate_camera()
                this.errores_guard = this.$t('mensaje_qr_no_valido')
                this.head_color = 'red display-1 text--primary justify-center'
                this.dialog_errores = true
              }
              if (error.request.status === 401) {
                this.valido = false
                console.log('Invitacion Expirada')
                this.clear_without_activate_camera()
                this.errores_guard = this.$t('msg_out_date2')
                this.head_color = 'red display-1 text--primary justify-center'
                this.dialog_errores = true
              }
              if (error.request.status === 403) {
                this.valido = false
                console.log('NO Valido')
                this.clear_without_activate_camera()
                this.errores_guard = this.$t('msg_canceled_invitation')
                this.head_color = 'red display-1 text--primary justify-center'
                this.dialog_errores = true
              }
              if (error.request.status === 423) {
                this.valido = false
                console.log('NO Valido')
                this.clear_without_activate_camera()
                this.errores_guard = this.$t('msg_vacation_mode_activate')
                this.head_color = 'red display-1 text--primary justify-center'
                this.dialog_errores = true
              }
              if (error.request.status === 300) {
                this.valido = false
                console.log('Varios registros con el mismo Código QR.')
                this.clear_without_activate_camera()
                this.errores_guard = this.$t('mensaje_qr_multiple')
                this.head_color = 'red display-1 text--primary justify-center'
                this.dialog_errores = true
              }
            })
        }
      }
    },
    qr_is_valid (infoInvitation) {
      // console.log('Task  Data', infoInvitation[0].idHousingUnit, ' = ', this.getProfile.idHousingUnit)
      if (infoInvitation.length > 0 && infoInvitation[0].idHousingUnit === this.getProfile.idHousingUnit) {
        this.valido = true
        console.log('Valido')
        this.is_access_in_out_both()
      } else if (infoInvitation.length > 0 && infoInvitation[0].idHousingUnit !== this.getProfile.idHousingUnit) {
        this.valido = false
        console.log('NO Valido, Diferente Privada.')
        //     this.$store.commit('snackbar_activate_true')
        //     this.$store.commit('snackbar_change_color', 'error')
        //     this.$store.commit('snackbar_change_message', this.$t('mensaje_qr_no_valido'))
        //     setTimeout(this.clear, 3000)
        this.clear_without_activate_camera()
        this.errores_guard = this.$t('mensaje_qr_no_valido_fraccionamiento')
        this.head_color = 'red display-1 text--primary'
        this.dialog_errores = true
      } else {
        this.valido = false
        console.log('NO Valido')
        //     this.$store.commit('snackbar_activate_true')
        //     this.$store.commit('snackbar_change_color', 'error')
        //     this.$store.commit('snackbar_change_message', this.$t('mensaje_qr_no_valido'))
        //     setTimeout(this.clear, 3000)
        this.clear_without_activate_camera()
        this.errores_guard = this.$t('mensaje_qr_no_valido')
        this.head_color = 'red display-1 text--primary'
        this.dialog_errores = true
      }
    },
    clear_without_activate_camera: function () {
      this.dialog = false
      this.activar_camara = false
      this.qr_code = ''
      this.a_qr_code = ''
      this.entrada = false
      this.salida = false
      this.entradaTrabajador = false
      this.salidaTrabajador = false
      this.entradaContratista = false
      this.salidaContratista = false
      // qrDetected y QR scanning se reanudan via el watch de activar_camara
    },
    is_access_in_out_both: function () {
      if (this.a_qr_code.length > 10) {
        this.qr_code = this.a_qr_code
      }
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/Access/Get/ByCode/' + this.qr_code + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.data_access = response.data
          console.log(this.data_access)
          if (this.info_invitation.invitation.typeInv === 0) { // Tipo de Invitación Normal
            if (response.data.length > 0 && response.data[0].dateTime_EntranceAccess != null && response.data[0].dateTime_ExitAccess != null) {
              // alert('Ya se completó el acceso con la invitación Correspondiente.')
              console.log('COMPLETO')
              this.clear_without_activate_camera()
              this.head_color = 'orange display-1 text--primary'
              this.errores_guard = this.$t('mensaje_acceso_completo')
              this.dialog_errores = true
            } else {
              // this.get_equipo_invitacion()
              if (response.data.length > 0) {
                this.entrada = false
                this.salida = true
                this.entradaResidente = false
                this.entradaTrabajador = false
                this.salidaTrabajador = false
                this.entradaContratista = false
                this.salidaContratista = false
                this.dialog = true
                this.activar_camara = false
                console.log('SALIDA')
              } else {
                console.log('ENTRADA')
                if (this.info_invitation.invitation.temporalToken === '') {
                  this.comments = ''
                  this.entrada = true
                  this.salida = false
                  this.entradaResidente = false
                  this.entradaTrabajador = false
                  this.salidaTrabajador = false
                  this.entradaContratista = false
                  this.salidaContratista = false
                  this.dialog = true
                  this.activar_camara = false
                } else {
                  localStorage.setItem('qr_code_temporal', this.qr_code)
                  localStorage.setItem('host_IdFront', this.info_invitation.invitation.hostIdFront)
                  localStorage.setItem('host_avatar', this.info_invitation.invitation.avatarHost)
                  localStorage.setItem('host_first_name', this.info_invitation.invitation.hostFirstName)
                  localStorage.setItem('host_last_name', this.info_invitation.invitation.hostLastName)
                  localStorage.setItem('host_cellphone', this.info_invitation.invitation.hostCellphone)
                  localStorage.setItem('host_street', this.info_invitation.invitation.street)
                  localStorage.setItem('host_number_house', this.info_invitation.invitation.numberHouse)
                  localStorage.setItem('host_supplier', this.info_invitation.invitation.supplier)
                  localStorage.setItem('vacation_mode', this.info_invitation.invitation.vacation_mode)
                  localStorage.setItem('allow_access_visitors', this.info_invitation.invitation.allow_access_visitors)
                  this.$router.push('/booth_registration/' + this.info_invitation.invitation.temporalToken)
                }
              }
            }
          }
          if (this.info_invitation.invitation.typeInv === 1) { // Tipo de Invitación Pre registro en Caseta
            if (response.data.length > 0 && response.data[0].dateTime_EntranceAccess != null && response.data[0].dateTime_ExitAccess != null) {
              // alert('Ya se completó el acceso con la invitación Correspondiente.')
              console.log('COMPLETO')
              this.clear_without_activate_camera()
              this.head_color = 'orange display-1 text--primary'
              this.errores_guard = this.$t('mensaje_acceso_completo')
              this.dialog_errores = true
            } else {
              if (response.data.length > 0) {
                this.entrada = false
                this.salida = true
                this.entradaResidente = false
                this.entradaTrabajador = false
                this.salidaTrabajador = false
                this.entradaContratista = false
                this.salidaContratista = false
                this.dialog = true
                this.activar_camara = false
                console.log('SALIDA')
              } else {
                console.log('ENTRADA')
                if (this.info_invitation.invitation.temporalToken === '') {
                  this.comments = ''
                  this.entrada = true
                  this.salida = false
                  this.entradaResidente = false
                  this.entradaTrabajador = false
                  this.salidaTrabajador = false
                  this.entradaContratista = false
                  this.salidaContratista = false
                  this.dialog = true
                  this.activar_camara = false
                } else {
                  localStorage.setItem('qr_code_temporal', this.qr_code)
                  localStorage.setItem('host_IdFront', this.info_invitation.invitation.hostIdFront)
                  localStorage.setItem('host_avatar', this.info_invitation.invitation.avatarHost)
                  localStorage.setItem('host_first_name', this.info_invitation.invitation.hostFirstName)
                  localStorage.setItem('host_last_name', this.info_invitation.invitation.hostLastName)
                  localStorage.setItem('host_cellphone', this.info_invitation.invitation.hostCellphone)
                  localStorage.setItem('host_street', this.info_invitation.invitation.street)
                  localStorage.setItem('host_number_house', this.info_invitation.invitation.numberHouse)
                  localStorage.setItem('host_supplier', this.info_invitation.invitation.supplier)
                  localStorage.setItem('vacation_mode', this.info_invitation.invitation.vacation_mode)
                  localStorage.setItem('allow_access_visitors', this.info_invitation.invitation.allow_access_visitors)
                  this.$router.push('/booth_registration/' + this.info_invitation.invitation.temporalToken)
                }
              }
            } // Tipo de Invitación Recurrente
          }
          if (this.info_invitation.invitation.typeInv === 2) { // Tipo de Invitación Recurrente
            if (response.data.length === 0) {
              console.log('ENTRADA RECURRENTE')
              if (this.info_invitation.invitation.temporalToken === '') {
                this.comments = ''
                this.entrada = true
                this.salida = false
                this.entradaResidente = false
                this.entradaTrabajador = false
                this.salidaTrabajador = false
                this.entradaContratista = false
                this.salidaContratista = false
                this.dialog = true
                this.activar_camara = false
              } else {
                localStorage.setItem('qr_code_temporal', this.qr_code)
                localStorage.setItem('host_IdFront', this.info_invitation.invitation.hostIdFront)
                localStorage.setItem('host_avatar', this.info_invitation.invitation.avatarHost)
                localStorage.setItem('host_first_name', this.info_invitation.invitation.hostFirstName)
                localStorage.setItem('host_last_name', this.info_invitation.invitation.hostLastName)
                localStorage.setItem('host_cellphone', this.info_invitation.invitation.hostCellphone)
                localStorage.setItem('host_street', this.info_invitation.invitation.street)
                localStorage.setItem('host_number_house', this.info_invitation.invitation.numberHouse)
                localStorage.setItem('host_supplier', this.info_invitation.invitation.supplier)
                localStorage.setItem('vacation_mode', this.info_invitation.invitation.vacation_mode)
                localStorage.setItem('allow_access_visitors', this.info_invitation.invitation.allow_access_visitors)
                this.$router.push('/booth_registration/' + this.info_invitation.invitation.temporalToken)
              }
            } else {
              if (response.data[0].status === 1) {
                this.entrada = false
                this.salida = true
                this.entradaResidente = false
                this.entradaTrabajador = false
                this.salidaTrabajador = false
                this.entradaContratista = false
                this.salidaContratista = false
                this.dialog = true
                this.activar_camara = false
                console.log('SALIDA RECURRENTE', response.data[0])
              } else {
                var fechaLocal = new Date(this.get_current_date())
                const readableDate = response.data[0].dateTime_EntranceAccess.substring(3, 6) + response.data[0].dateTime_EntranceAccess.substring(0, 2) + response.data[0].dateTime_EntranceAccess.substring(5, 10)
                var fechaAccesoEntrada = new Date(readableDate)
                if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                  this.comments = ''
                  this.entrada = true
                  this.salida = false
                  this.entradaResidente = false
                  this.entradaTrabajador = false
                  this.salidaTrabajador = false
                  this.entradaContratista = false
                  this.salidaContratista = false
                  this.dialog = true
                  this.activar_camara = false
                  console.log('ENTRADA RECURRENTE')
                } else {
                  console.log('COMPLETO RECURRENTE')
                  this.clear_without_activate_camera()
                  this.head_color = 'orange display-1 text--primary'
                  this.errores_guard = this.$t('mensaje_acceso_completo')
                  this.dialog_errores = true
                }
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    create_acceso: function () {
      console.log(this.qr_code)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/Access/Create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          qr_code: this.qr_code,
          comments: this.comments,
          id_guardhouse_checkin: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          // this.$store.commit('snackbar_activate_true')
          // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
          // this.dialog = false
          // setTimeout(this.clear, 3000);
          // console.log(this.info_invitation)
          localStorage.removeItem('qr_code_temporal')
          this.clear_without_activate_camera()
          this.errores_guard = this.$t('mensaje_alta_acceso_in')
          this.head_color = 'green display-1 text--primary'
          this.dialog_errores = true
        })
        .catch(error => {
          console.log(error.response.data)
          this.clear_without_activate_camera()
          this.head_color = 'red display-1 text--primary'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    create_worker_acceso: function () {
      console.log(this.qr_code)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/WorkerAccess/Create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          qr_code: this.info_invitation.worker.qr_code,
          comments: this.comments,
          guard_house: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          localStorage.removeItem('qr_code_temporal')
          if (this.entradaTrabajador === true) {
            this.errores_guard = this.$t('mensaje_alta_acceso_in')
          }
          if (this.salidaTrabajador === true) {
            this.errores_guard = this.$t('mensaje_alta_acceso_out')
          }
          this.clear_without_activate_camera()
          this.head_color = 'green display-1 text--primary'
          this.dialog_errores = true
        })
        .catch(error => {
          console.log(error.response.data)
          this.clear_without_activate_camera()
          this.head_color = 'red display-1 text--primary'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    create_contractor_acceso: function () {
      console.log(this.qr_code)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/contractorAccess/Create/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          qr_code: this.info_invitation.contractor.qr_code,
          comments: this.comments,
          guard_house: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          localStorage.removeItem('qr_code_temporal')
          if (this.entradaContratista === true) {
            this.errores_guard = this.$t('mensaje_alta_acceso_in')
          }
          if (this.salidaContratista === true) {
            this.errores_guard = this.$t('mensaje_alta_acceso_out')
          }
          this.clear_without_activate_camera()
          this.head_color = 'green display-1 text--primary'
          this.dialog_errores = true
        })
        .catch(error => {
          console.log(error.response.data)
          this.clear_without_activate_camera()
          this.head_color = 'red display-1 text--primary'
          this.errores_guard = error.response.data.error
          this.dialog_errores = true
        })
    },
    update_acceso: function (pk) {
      console.log(this.qr_code)
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/Access/Update/' + pk,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          this.clear_without_activate_camera()
          this.head_color = 'green display-1 text--primary'
          this.errores_guard = this.$t('mensaje_alta_acceso_out')
          this.dialog_errores = true
          // this.$store.commit('snackbar_activate_true')
          // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_out'))
          // setTimeout(this.clear, 3000);
        })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    is_contractor_access_in_out_both () {
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/contractorAccess/Status/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          'qr_code': this.info_invitation.contractor.qr_code
        }
      }
      axios(config)
        .then(response => {
          switch (response.data.status) {
            case 10:
              console.log('ENTRADA CONTRATISTA')
              this.comments = ''
              this.entrada = false
              this.salida = false
              this.entradaResidente = false
              this.entradaTrabajador = false
              this.salidaTrabajador = false
              this.entradaContratista = true
              this.salidaContratista = false
              this.dialog = true
              this.activar_camara = false
              this.playSound(require('../../assets/mp3/success01.mp3'))
              break
            case 11:
              this.playSound(require('../../assets/mp3/success01.mp3'))
              console.log('SALIDA CONTRATISTA')
              this.entrada = false
              this.salida = false
              this.entradaResidente = false
              this.entradaTrabajador = false
              this.salidaTrabajador = false
              this.entradaContratista = false
              this.salidaContratista = true
              this.dialog = true
              this.activar_camara = false
              break
            case 12:
              this.playSound(require('../../assets/mp3/error01.mp3'))
              this.clear_without_activate_camera()
              this.head_color = 'red display-1 text--primary'
              this.errores_guard = this.$t('msg_out_date_contractor0')
              this.dialog_errores = true
              break
            case 13:
              this.playSound(require('../../assets/mp3/error01.mp3'))
              this.clear_without_activate_camera()
              this.head_color = 'red display-1 text--primary'
              this.errores_guard = this.$t('msg_out_date_contractor1')
              this.dialog_errores = true
              break
            case -2:
              this.playSound(require('../../assets/mp3/error01.mp3'))
              this.clear_without_activate_camera()
              this.head_color = 'red display-1 text--primary'
              this.errores_guard = this.$t('msg_out_date_contractor2')
              this.dialog_errores = true
              break
          }
        })
        .catch(error => {
          console.log(error.response.data)
        })
    },
    is_worker_access_in_out_both () {
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/WorkerAccess/Status/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          'qr_code': this.info_invitation.worker.qr_code
        }
      }
      axios(config)
        .then(response => {
          switch (response.data.status) {
            case 10:
              console.log('ENTRADA TRABAJADOR')
              this.comments = ''
              this.entrada = false
              this.salida = false
              this.entradaResidente = false
              this.entradaTrabajador = true
              this.salidaTrabajador = false
              this.entradaContratista = false
              this.salidaContratista = false
              this.dialog = true
              this.activar_camara = false
              this.playSound(require('../../assets/mp3/success01.mp3'))
              break
            case 11:
              this.playSound(require('../../assets/mp3/success01.mp3'))
              console.log('SALIDA TRABAJADOR')
              this.entrada = false
              this.salida = false
              this.entradaResidente = false
              this.entradaTrabajador = false
              this.salidaTrabajador = true
              this.entradaContratista = false
              this.salidaContratista = false
              this.dialog = true
              this.activar_camara = false
              break
            case 12:
              this.playSound(require('../../assets/mp3/error01.mp3'))
              this.clear_without_activate_camera()
              this.head_color = 'red display-1 text--primary'
              this.errores_guard = this.$t('msg_out_date_worker0')
              this.dialog_errores = true
              break
            case 13:
              this.playSound(require('../../assets/mp3/error01.mp3'))
              this.clear_without_activate_camera()
              this.head_color = 'red display-1 text--primary'
              this.errores_guard = this.$t('msg_out_date_worker1')
              this.dialog_errores = true
              break
          }
        })
        .catch(error => {
          console.log(error.response.data)
        })
    },
    getGuardHouse: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/guardhouse/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.guardHouses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    setGuardHouse () {
      if (this.guardHouse !== null) {
        localStorage.setItem('idGuardHouse', this.guardHouse)
        this.dialogInitial = false
      }
    },
    get_current_date () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = mm + '/' + dd + '/' + yyyy
      return today
    }
  }
}
</script>

<style scoped>
    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #439f46;
        color: white;
    }
    .edge {
        border-radius: 8px;
        border-color: #439f46 #439f46 #439f46 #439f46;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }

    .tournament-preview-card {
      border-radius: 16px;
      overflow: hidden;
      background: linear-gradient(180deg, #f2f7fd 0%, #ffffff 100%);
    }

    .tournament-toolbar {
      background: #1565C0 !important;
    }

    .tournament-avatar {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #1565C0;
      color: white;
      font-size: 1.6rem;
      font-weight: 700;
      margin: 0 auto;
      box-shadow: 0 8px 20px rgba(21, 101, 192, 0.3);
      letter-spacing: 0.02em;
    }

    .tournament-summary {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
    }

    .tournament-kicker {
      color: #1565C0;
      font-size: 0.68rem;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      font-weight: 700;
      margin-bottom: 4px;
    }

    .tournament-name {
      font-size: clamp(1.3rem, 1.8vw, 1.6rem);
      line-height: 1.25;
      margin: 0;
      color: #212121;
      font-weight: 700;
    }

    .tournament-event {
      margin-top: 6px;
      font-size: 0.9rem;
      color: #616161;
      font-weight: 500;
    }

    .tournament-info-box {
      background: #eaf2fb;
      border: 1px solid rgba(21, 101, 192, 0.15);
      border-radius: 10px;
      padding: 10px 14px;
      min-height: 66px;
      margin-bottom: 12px;
    }

    .info-label {
      font-size: 0.66rem;
      text-transform: uppercase;
      letter-spacing: 0.08em;
      color: #0D47A1;
      font-weight: 700;
      margin-bottom: 4px;
    }

    .info-value {
      font-size: 0.98rem;
      line-height: 1.35;
      color: #263238;
      font-weight: 600;
      word-break: break-word;
    }

    .guest-sublist {
      background: #f5f8fc;
      border: 1px solid rgba(21, 101, 192, 0.15);
      border-radius: 10px;
      overflow: hidden;
    }

    .guest-row:not(:last-child) {
      border-bottom: 1px solid rgba(21, 101, 192, 0.1);
    }
</style>
